/* eslint-disable indent */
import React from "react";
import PropTypes from "prop-types";

import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  // renderAccessLocation2,
  renderLocationFunction
} from "../../../constant/helper/helper";
import Button from "../../../component/button/Button";
import SelectInput2 from "../../../component/input/SelectInput2";
import TextInput from "../../../component/input/TextInput";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import TextInput2 from "../../../component/input/TextInput2";
import RenderToolTip from "../../../component/tooltip/RenderToolTip";
import { toolTipData } from "../../attendance/attendanceSheet/sheetStaticData";
import SelectInput from "../../../component/input/SelectInput";

const TopInput = ({
  values,
  loading,
  onSubmit,
  onChange,
  allLocations,
  currentUser,
  allRules,
  onUpdateShift
}) => {
  return (
    <div className="row">
      <RenderToolTip toolTipData={toolTipData} />
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <TextInput2
          data-tip
          type="date"
          name="fromDate"
          onChange={onChange}
          value={values.fromDate}
          data-for="fromDate"
          icon="mdi mdi-calendar-check"
          placeholder="Select From Date"
        />
      </div>
      <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2">
        <TextInput2
          data-tip
          type="date"
          name="toDate"
          onChange={onChange}
          value={values.toDate}
          data-for="toDate"
          icon="mdi mdi-calendar-check"
          placeholder="Select To Date"
        />
      </div>

      <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <SelectInput2
          data-tip
          name="locationId"
          isLabeled={true}
          onChange={onChange}
          icon="mdi mdi-map-marker-radius"
          data-for="locationName"
          label="Select Location"
          value={values.locationId}
          placeholder="Select Location"
        >
          {isSuperAdmin(currentUser)
            ? renderLocationFunction(allLocations)
            : renderAccessLocation2(
                locationRender(currentUser, false)
              )}
        </SelectInput2>
      </div>

      {loading ? (
        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2">
          <SpinnerButton />
        </div>
      ) : (
        <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2">
          <div className="form-group">
            <Button
              type="button"
              onClick={onSubmit}
              title="GET"
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn mb-2 text-white btn-dark btn-block"
            />
          </div>
        </div>
      )}
      <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <TextInput2
          data-tip
          type="text"
          name="Filter"
          data-for="Filter"
          onChange={onChange}
          value={values.Filter}
          icon="mdi mdi-magnify"
          placeholder="Search..."
        />
      </div>
      <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
        <div className="form-group">
          <Button
            type="button"
            title="Update Shift"
            data-toggle="modal"
            data-target="#update_shift"
            isBackgroundColor={false}
            icon="mdi mdi-plus-circle-outline mr-2"
            className="btn mb-2 text-white btn-primary btn-block"
          />
        </div>

        <div
          className="modal fade"
          id="update_shift"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="fullWidthModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog  modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title" id="fullWidthModalLabel">
                  Update Shift
                </h4>

                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                >
                  ×
                </button>
              </div>

              <form className="pl-3 pr-3" onSubmit={onUpdateShift}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-12">
                      <h4 className="mt-1">Update Employee Shift</h4>
                      <p className="text-muted mb-2">
                        Fill the form below to Update Shift .
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                      <TextInput2
                        data-tip
                        type="date"
                        name="updateDate"
                        onChange={onChange}
                        value={values.updateDate}
                        data-for="updateDate"
                        icon="mdi mdi-calendar-check"
                        placeholder="Select From Date"
                      />
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-4">
                      <SelectInput2
                        data-tip
                        isLabeled={true}
                        onChange={onChange}
                        name="updateLocation"
                        label="Select Location"
                        data-for="updateLocation"
                        value={values.updateLocation}
                        placeholder="Select Location"
                        icon="mdi mdi-map-marker-radius"
                      >
                        {isSuperAdmin(currentUser)
                          ? renderLocationFunction(allLocations)
                          : renderAccessLocation2(
                              locationRender(currentUser, false)
                            )}
                      </SelectInput2>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                      <SelectInput2
                        data-tip
                        isLabeled={true}
                        name="updateShift"
                        label="Select Rule"
                        onChange={onChange}
                        data-for="updateShift"
                        placeholder="Select Rule"
                        value={values.updateShift}
                        icon="mdi mdi-textbox-password"
                      >
                        {allRules.map((rule, index) => (
                          <option value={rule._id} key={index}>
                            {rule.shiftCode +
                              " / " +
                              rule.shiftIn +
                              " - " +
                              rule.shiftOut}
                          </option>
                        ))}
                      </SelectInput2>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                      <SelectInput
                        required={true}
                        name="weeklyOff"
                        textWhite={false}
                        isLabeled={false}
                        onChange={onChange}
                        value={values.weeklyOff}
                        label="Select Weekly-Off or Not"
                      >
                        <option value=""> Weekly-off ?</option>
                        <option value="true"> YES</option>
                        <option value="false"> NO</option>
                      </SelectInput>
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                      <TextInput
                        data-tip
                        type="text"
                        name="workerId"
                        onChange={onChange}
                        data-for="workerId"
                        label="Enter Worker Id"
                        value={values.workerId}
                        icon="mdi mdi-calendar-check"
                        placeholder="Enter Worker Id"
                      />
                    </div>
                    <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                      <SelectInput
                        required={true}
                        name="weekOffDay"
                        textWhite={false}
                        isLabeled={false}
                        onChange={onChange}
                        value={values.weekOffDay}
                        label="Select Weekly-Off Day"
                      >
                        <option value="">
                          Select Weekly-off Day
                        </option>
                        <option value="SUNDAY"> SUNDAY</option>
                        <option value="MONDAY"> MONDAY</option>
                        <option value="TUESDAY"> TUESDAY</option>
                        <option value="WEDNESDAY"> WEDNESDAY</option>
                        <option value="THURSDAY"> THURSDAY</option>
                        <option value="FRIDAY"> FRIDAY</option>
                        <option value="SATURDAY"> SATURDAY</option>
                      </SelectInput>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button
                    type="button"
                    title="Close"
                    data-dismiss="modal"
                    className="btn btn-light"
                    isBackgroundColor={false}
                  />
                  {loading ? (
                    <SpinnerButton />
                  ) : (
                    <Button
                      type="submit"
                      title="Update Shift"
                      className="btn btn-dark"
                      isBackgroundColor={false}
                      icon="mdi mdi-plus-circle-outline mr-2"
                    />
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8">
        <h4 className="text-danger">
          Please After Shift Update Press Get Button Again to Get the
          latest updated Shifts
        </h4>
      </div>
    </div>
  );
};

TopInput.propTypes = {
  loading: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onUpdateShift: PropTypes.func.isRequired,
  allLocations: PropTypes.array.isRequired,
  allRules: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired
};

export default TopInput;
